module.exports = __webpack_public_path__ + "static/media/buy_req_help_actual.8d8c0d89.png";